import { useQuery } from '@apollo/client/react';
import { Grid } from '@mui/material';
import { isEqual, map } from 'lodash';
import React, { useContext, useState } from 'react';

import DrawerFilters from './DrawerFilters';
import ShowTaskModal from './ShowTaskModal';
import TaskCard from './TaskCard';

import { DEFAULT_FILTERS, type TasksFiltersType } from '@/components/ManagerComponents/ManagerTabs/TasksTab';
import CurrentUserContext from '@/Contexts/CurrentUser';
import { type GetTasksQuery, GetTasksDocument } from '@/graphql/generated/graphql';

const DrawerTasks: React.FC = () => {
  const { currentUser } = useContext(CurrentUserContext);
  const [currentTask, setCurrentTask] = useState<NonNullable<GetTasksQuery['getTasks']>[0] | null>(null);
  const [filters, setFilters] = useState<TasksFiltersType>(DEFAULT_FILTERS);

  const { data } = useQuery(GetTasksDocument, {
    fetchPolicy: 'cache-and-network',
    skip: !currentUser?.defaultCompany?.id,
    variables: {
      ...filters,
      dueDateFrom: filters.dueDateFrom ? filters.dueDateFrom.toISOString() : null,
      dueDateTo: filters.dueDateTo ? filters.dueDateTo.toISOString() : null,
    },
  });

  return (
    <React.Fragment>
      <DrawerFilters
        filters={filters}
        onChange={(key, value) => setFilters((prev) => ({ ...prev, [key]: value }))}
        onReset={() => setFilters(DEFAULT_FILTERS)}
        disableResetButton={isEqual(filters, DEFAULT_FILTERS)}
      />
      <Grid container alignContent="flex-start" size={12}>
        {map(data?.getTasks, (task, index) => (
          <TaskCard task={task} onClick={() => setCurrentTask(task)} key={`tasks-list-${task.id}-${index}`} />
        ))}
      </Grid>
      {currentTask && <ShowTaskModal handleClose={() => setCurrentTask(null)} taskId={currentTask.id} />}
    </React.Fragment>
  );
};

export default DrawerTasks;
